const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  systemType: state => state.systems.systemType,
  isSafing: state => state.systems.isSafing,
  systemId: state => state.systems.systemId,
  userInfo: state => state.user.info, // 用户信息
  getLoginAuthForm: state => state.auth.loginAuthForm,

}
export default getters
